import React, { useEffect, useState } from 'react';
import {
  FDAccordion, FDAccordionDetails, FDAccordionGroup, FDAccordionTitle,
  FDBodyText, FDBox, FDPaper, FDStack, FDSwitchInput, FDTitleText,
} from '@facet-wealth/design';
import { GuidedHouseholdReviewLineItem } from 'Components/UI/guidedHouseholdReview/lineItem';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

export const GuidedHouseholdReviewSection = ({ outlined }) => {
  const { resource } = useMetaLayoutContext();

  const canBeSeenMonthly = resource.attr('canBeSeenMonthly') === 'true';
  const [viewAnnually, setViewAnnually] = useState(resource.attr('defaultToMonthlyView') !== 'true' || !canBeSeenMonthly);
  useEffect(() => {
    if (!canBeSeenMonthly) setViewAnnually(true);
  }, [canBeSeenMonthly]);
  const multiplyValuesBy = viewAnnually ? 1 : 1 / 12;
  const monthlySwitch = canBeSeenMonthly ? (
    <FDStack direction="row" justifyContent="center">
      <FDStack direction={'row'} alignItems={'center'} spacing={1.5}>
        <FDBodyText value={'Monthly'} />
        <FDSwitchInput label="Annual" value={viewAnnually} onChange={setViewAnnually} />
      </FDStack>
    </FDStack>
  ) : null;

  const lineItems = resource.attr('lineItems').resources().list();
  if (lineItems.length === 0) {
    return null;
  }

  const headline = lineItems[0];
  const nonHeadlineLineItems = lineItems.slice(1);
  const headlineText = headline.attr('name');

  if (nonHeadlineLineItems.length === 0) {
    return (
      <FDPaper padding={outlined ? 3 : 0} appearance={outlined ? 'outlined' : 'flat'}>
        <FDStack direction="column" spacing={1}>
          <FDTitleText value={headlineText} />
          <FDBodyText value={`No ${headlineText.toLowerCase()}.`} />
        </FDStack>
      </FDPaper>
    );
  }

  if (resource.attr('collapsable') !== 'true') {
    return (
      <>
        <FDPaper padding={outlined ? 3 : 0} appearance={outlined ? 'outlined' : 'flat'}>
          <FDStack direction="column" spacing={1}>
            {lineItems.map(lineItem => (
              lineItem.attr('bold') === 'true' ? (
                <>
                  <FDBox paddingY={1}>
                    <GuidedHouseholdReviewLineItem key={lineItem.id()} resource={lineItem} multiplyBy={multiplyValuesBy} viewAnnually={viewAnnually} />
                  </FDBox>
                </>
              ) : (
                <GuidedHouseholdReviewLineItem key={lineItem.id()} resource={lineItem} multiplyBy={multiplyValuesBy} viewAnnually={viewAnnually} />
              )
            ))}
            {monthlySwitch}
          </FDStack>
        </FDPaper>
      </>
    );
  }

  return (
    <FDPaper padding={outlined ? 3 : 0} appearance={outlined ? 'outlined' : 'flat'}>
      <FDAccordionGroup>
        <FDAccordion expansionID={resource.id()}>
          <FDAccordionTitle>
            <GuidedHouseholdReviewLineItem resource={headline} multiplyBy={multiplyValuesBy} viewAnnually={viewAnnually} />
          </FDAccordionTitle>
          <FDAccordionDetails>
            <FDStack direction="column" spacing={1}>
              {nonHeadlineLineItems.map(lineItem => (
                lineItem.attr('bold') === 'true' ? (
                  <>
                    <FDBox paddingY={1}>
                      <GuidedHouseholdReviewLineItem key={lineItem.id()} resource={lineItem} multiplyBy={multiplyValuesBy} viewAnnually={viewAnnually} />
                    </FDBox>
                  </>
                ) : (
                  <GuidedHouseholdReviewLineItem key={lineItem.id()} resource={lineItem} multiplyBy={multiplyValuesBy} viewAnnually={viewAnnually} />
                )
              ))}
              {monthlySwitch}
            </FDStack>
          </FDAccordionDetails>
        </FDAccordion>
      </FDAccordionGroup>
    </FDPaper>
  );
};
